/* ---
	Product Detail

	Two small behaviours for the product detail section:
	  - <product-accordion> toggles a disclosure row (作品情報 etc.)
	  - <product-read-more> reveals the clamped description on mobile
--- */

if (typeof ProductAccordion !== 'function') {
  class ProductAccordion extends HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('[data-accordion-header]');
      this.panel = this.querySelector('[data-accordion-panel]');
      if (!this.header || !this.panel) return;

      this.header.addEventListener('click', this.#toggle.bind(this));
    }

    #toggle() {
      const isOpen = this.header.getAttribute('aria-expanded') === 'true';
      this.header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      this.panel.hidden = isOpen;
    }
  }

  customElements.define('product-accordion', ProductAccordion);
}

if (typeof ProductReadMore !== 'function') {
  class ProductReadMore extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-read-more-toggle]');
      this.label = this.querySelector('[data-read-more-label]');
      if (!this.toggle) return;

      this.labelMore = this.toggle.dataset.labelMore || '';
      this.labelLess = this.toggle.dataset.labelLess || this.labelMore;

      this.toggle.addEventListener('click', this.#onToggle.bind(this));
    }

    #onToggle() {
      const isClamped = this.classList.contains('kt-product-detail__description--clamped');
      this.classList.toggle('kt-product-detail__description--clamped', !isClamped);
      this.toggle.setAttribute('aria-expanded', isClamped ? 'true' : 'false');
      if (this.label) {
        this.label.textContent = isClamped ? this.labelLess : this.labelMore;
      }
    }
  }

  customElements.define('product-read-more', ProductReadMore);
}
